import { put } from 'redux-saga/effects';
import { collectionIsLoadingAction, collectionSetInStoreAction } from 'common/actions';
import { fetchSavedVideosApi } from 'common/api';
import { errorHandleAction } from 'components/error-handle/actions';
import { savedVideosSuccessAction } from 'pages/saved-videos.page';

export function* requestSavedVideosEffect({ payload }) {
  try {
    yield put(collectionIsLoadingAction());
    const collection = yield fetchSavedVideosApi(payload.userId, payload.perPage, payload.pageNumber, payload.sort);
    yield put(collectionSetInStoreAction(collection));
    yield put(savedVideosSuccessAction(collection));
  } catch (error) {
    yield put(errorHandleAction(error, error.status));
  }
}

export function* requestSavedVideosMobileEffect({ payload }) {
  try {
    yield put(collectionIsLoadingAction());

    const { userId, perPage, prevVideos, sort } = payload;
    let { pageNumber } = payload;
    pageNumber = ++pageNumber;

    const collection = yield fetchSavedVideosApi(userId, perPage, pageNumber, sort);

    if (pageNumber > 1) {
      collection.videos = [].concat(prevVideos, collection.videos);
      collection.pageNum = pageNumber;
    }

    yield put(collectionSetInStoreAction(collection));
    yield put(savedVideosSuccessAction(collection));
  } catch (error) {
    yield put(errorHandleAction(error, error.status));
  }
}
